import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import KycOverview from "./KycOverview";
import KycFormIntegration from "./KycFormIntegration";
import BuildWithLlm from "../BuildWithLlm";
import { kycTabs } from "./KycTabs";
import kycBuildWithLlmFile from "../../../assets/markDownFiles/id/build_with_llm.md";

// Panels are keyed by SLUG, not by array position, so adding/removing a tab in
// `kycTabs` can never leave the panels misaligned with the tabs.
const panelsBySlug = {
  "kyc-overview": <KycOverview />,
  // The slug predates the Form Integration Guide; kept so existing links work.
  "kyc-id-integration": <KycFormIntegration />,
  "kyc-build-with-llm": <BuildWithLlm file={kycBuildWithLlmFile} product="ACT ID (KYC)" />,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      sx={{
        height: "100vh",
        overflowY: "auto",
        boxSizing: "border-box",
      }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function KycTabPanels({ value }) {
  // Derive the rendered panels from the tabs themselves, in tab order.
  const contentTabs = kycTabs.filter((t) => !t.isHeader);

  return (
    <>
      {contentTabs.map((tab, index) => (
        <TabPanel key={tab.slug} value={value} index={index}>
          {panelsBySlug[tab.slug] ?? null}
        </TabPanel>
      ))}
    </>
  );
}

export default KycTabPanels;
